
import { useEffect, useState } from 'react';
import { useInactivityLogout } from '@/hooks/useInactivityLogout';
import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/integrations/supabase/client';

const InactivityHandler = () => {
  const { isAdmin, user } = useAuth();
  const [timeoutMinutes, setTimeoutMinutes] = useState<number>(20);

  useEffect(() => {
    const loadTimeoutSetting = async () => {
      // Only load settings if user is actually authenticated and admin
      if (!isAdmin || !user) return;
      
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('value')
          .eq('key', 'admin_session_timeout_minutes')
          .single();

        if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
          throw error;
        }

        if (data?.value) {
          const minutes = parseInt(data.value);
          if (minutes >= 1 && minutes <= 480) {
            setTimeoutMinutes(minutes);
          }
        }
      } catch (error) {
        console.error('Error loading timeout setting:', error);
        // Keep default of 20 minutes on error
      }
    };

    loadTimeoutSetting();
  }, [isAdmin, user]);
  
  // Enable inactivity logout only for authenticated admin users
  useInactivityLogout({
    timeoutMinutes,
    enabled: isAdmin && user !== null
  });

  return null; // This component doesn't render anything
};

export default InactivityHandler;
